import React from 'react';
import { LoginComponent } from '@liepin/react-login4c-pc';
import styled from './index._less';

const HomeLogin = () => {

  return (
    <>
      <div className="home-banner-login">
        <div className="home-banner-login-container">
          <LoginComponent />
        </div>
      </div>
      <style jsx>{ styled }</style>
    </>
  )
}

export default HomeLogin;
